<script setup lang="ts">
interface StepperDividerProps {
  leftColor: string;
  dividerColor: string;
  rightColor: string;
}

defineProps<StepperDividerProps>();

</script>
<template>
  <div class="flex gap-0 h-full">
    <svg
      width="10"
      height="28"
      viewBox="0 0 10 28"
      fill="#ff0000"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 14.9997L0 27.9997V0L8 14.9997Z" :fill="leftColor" />
      <path d="M2 0H10V15V28H2L10 15L2 0Z" :fill="rightColor" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 15L2 28L0 27.9997L8 14.9997L0 0H2L10 15Z"
        :fill="dividerColor"
      />
    </svg>
  </div>
</template>
